import script from "./OccupationCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./OccupationCard.vue?vue&type=script&lang=ts&setup=true"

import "./OccupationCard.vue?vue&type=style&index=0&id=04225199&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04225199"]])

export default __exports__